export const CONSTS = {
  HEADER: $localize`COD Reconcile`,
  SUBMIT: $localize`Submit`,
  REQUIRED: $localize`! Required`,
  DOWNLOAD_CSV: $localize`Download CSV`,
};

export enum ColumnIds {
  STOP_DATE = 'stopDate',
  LOOP = 'loop',
  TRACKING_NUMBER = 'trackingNo',
  SHIPPER = 'shipper',
  PAY_AMOUNT = 'pmntAmount',
  PAY_TYPE = 'pmntType',
  STOP_TYPE = 'stopType',
  TURN_IN = 'turnIn',
  AMOUNT = 'codTurninAmount',
  COMMENTS = 'codTurninComments',
}

export const ColumnText = {
  STOP_DATE: $localize`Stop Date`,
  LOOP: $localize`Loop`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  SHIPPER: $localize`Shipper`,
  PAY_AMOUNT: $localize`Pay Amt`,
  PAY_TYPE: $localize`Pay Type`,
  STOP_TYPE: $localize`Stop Type`,
  TURN_IN: $localize`Turn In`,
  AMOUNT: $localize`Amt`,
  COMMENTS: $localize`Comments`,
};

export const MOCK_EDIT_COD_RECONCILE_RESPONSE = {
  code: 200,
  status: 'success',
  message: 'success',
};

export const COD_RECONCILE_MOCK_DATE = [
  {
    stopId: 1119116183,
    position: 0,
    stopDate: '06-28-2023',
    trackingNo: '1Z1271220206286448',
    loop: '001',
    locationCode: 'DEBIN',
    shipper: '127122',
    pmntAmount: 52,
    pmntCurrency: 'EUR',
    pmntType: 'CHEQUE',
    stopType: 'D',
    codTurninAmount: 52,
    codTurninCurrency: 'EUR',
    codTurninDate: '04-AUG-2023', // SYSTEM date when the turnin check box is checked and submit
    codTurninComments: 'TESTING',
  },
  {
    stopId: 1123686485,
    position: 1,
    stopDate: '07-14-2023',
    trackingNo: '1Z1271220207126734',
    loop: '03B',
    locationCode: 'DEBIN',
    shipper: '127122',
    pmntAmount: 84,
    pmntCurrency: 'EUR',
    pmntType: 'CHEQUE',
    stopType: 'D',
    codTurninAmount: 84,
    codTurninCurrency: 'EUR',
    codTurninDate: '04-AUG-2023', // SYSTEM date when the turnin check box is checked and submit
    codTurninComments: 'TEST',
  },
];
